import { Box, makeStyles } from "@material-ui/core";
import CustomChip from "./CustomChip";
import { useContext } from "react";
import clsx from "clsx";
import MessageContext from "../../context/MessageContext";
import useDeviceDetect from "../../hooks/useDeviceDetect";
import IndicatorPlan from "./IndicatorPlan";
const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    }
}));

export default function ContainerChips({ plan, className }) {
    const classes = useStyles();
    const { messages } = useContext(MessageContext);
    const { isMobile } = useDeviceDetect(900);
    return (
        (
            <Box className={clsx(classes.container, className)}>                
                {!isMobile && <>
                    {messages?.map(message => (
                        <CustomChip key={message.id} message={message} />
                    ))}
                </>}
                {plan?.info && <IndicatorPlan plan={plan} />}
            </Box>
        )
    );

}
